import { ref, withParams } from 'vuelidate/lib/validators/common';
import moment from 'moment';

export default (dateDiffLessThan, max) => withParams(
  { type: 'dateDiffLessThan', eq: dateDiffLessThan, max },
  function (value, parentVm) {
    const startDate = moment(value);
    const endDate = moment(ref(dateDiffLessThan, this, parentVm));
    startDate.startOf('day');
    endDate.startOf('day');
    const diff = Math.abs(startDate.diff(endDate, 'days'));
    return diff <= max;
  },
);
